export const TOKEN_KEYS = {
  BEARER: 'Authorization',
  GUEST: 'x-auth-guest',
  GHOST: 'x-auth-ghost',
  SESSION: 'x-auth-session',
};
